import { useBackgroundQuery } from '@apollo-internal/hooks/useBackgroundQuery';
import { orderBy } from 'lodash';
import GET_LEGAL_DOCUMENTS from '../queries/getLegalDocumentsQuery';
import LegalDocumentsMapper from '../mappers/LegalDocumentsMapper';

export const useLegalDocumentsData = orgId => {
  const { data, loading, error, refetch } = useBackgroundQuery(GET_LEGAL_DOCUMENTS, {
    fetchPolicy: 'cache-and-network',
    variables: { orgId, isActive: true },
    notifyOnNetworkStatusChange: true
  });

  const legalDocs = data ? LegalDocumentsMapper.toDataPage(data) : [];
  const orderedLegalDocuments = orderBy(legalDocs, x => x.completedDate, 'desc');
  const organization = data?.mddapOrganization;

  return {
    legalDocuments: orderedLegalDocuments,
    organization,
    loading,
    error,
    refetchLegalDocuments: refetch
  };
};
